// Copyright © 2021 Move Closer
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export var AdBannerSize;
(function (AdBannerSize) {
    AdBannerSize["MainContent"] = "main_content";
    AdBannerSize["MainIndex"] = "main_index";
    AdBannerSize["InText"] = "in_text";
    AdBannerSize["Medium"] = "medium";
    AdBannerSize["HorizontalMobile"] = "horizontal_mobile";
    AdBannerSize["Fullscreen"] = "fullscreen";
    AdBannerSize["Sticky"] = "sticky";
    AdBannerSize["StickyFixed"] = "sticky_fixed";
    AdBannerSize["StickyTeaser"] = "sticky_teaser";
})(AdBannerSize || (AdBannerSize = {}));
export var AdBannerVersion;
(function (AdBannerVersion) {
    AdBannerVersion["GoogleAds"] = "GoogleAds";
    AdBannerVersion["WayToGrow"] = "WTG";
})(AdBannerVersion || (AdBannerVersion = {}));
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export var AdBannerType;
(function (AdBannerType) {
    AdBannerType["Default"] = "default";
    AdBannerType["Sticky"] = "sticky";
    AdBannerType["StickyFixed"] = "sticky_fixed";
    AdBannerType["StickyTeaser"] = "sticky_teaser";
})(AdBannerType || (AdBannerType = {}));
